import axios from "axios";
import qs from "qs";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import NotFound from "../../common/NotFound/NotFound";
import s from "./ArticleCodeMP.module.css";
import robort from "../../common/assets/robot.gif";
import Loading from "../../common/loading/Loading";

const ArticleCodeMP = (props) => {
  const { id } = useParams();

  if (!id) {
    return (
      <div className={s.containerArticle}>
        <h1>This page displays an informational article about the smart doorphone system.</h1>
      </div>
    );
  }

  if (props.state.articleCodeMP.loading == true) {
    return (
      <div className={s.loading}>
        <Loading />
      </div>
    );
  }

  if (props.state.articleCodeMP.response.length != 0) {
    if (props.state.articleCodeMP.response.DATA) {
      return (
        <div className={s.containerArticle}>
          {props.state.articleCodeMP.response.DATA.map(function (item) {
            // Исправленные проверки - учитываем только непустые строки
            const hasTextLink = item.link_text && item.link_text.trim() !== "";
            const hasImageLink = item.link_image && item.link_image.trim() !== "";

            // Оборачиваем изображение или текст в ссылку, если есть linkto
            const imageElement = item.image ? (
              hasImageLink ? (
                <a href={item.link_image}>
                  <img
                    className={s.img}
                    src={item.image}
                  />
                </a>
              ) : (
                <img
                  className={s.img}
                  src={item.image}
                />
              )
            ) : null;

            const textElement = hasTextLink ? (
              <a href={item.link_text}>
                <p className={s.paragrafArticle}>{item.text}</p>
              </a>
            ) : (
              <p className={s.paragrafArticle}>{item.text}</p>
            );

            return (
              <div key={item.numberblock || item.header}>
                <h1 className={s.headerArticle}>{item.header}</h1>
                {imageElement}
                {textElement}
              </div>
            );
          })}
        </div>
      );
    } else if (
      props.state.articleCodeMP.response["message"] ===
        "Опаньки, какие-то не предвиденные ошибки :(" ||
      props.state.articleCodeMP.response["message"] === "Error #13.0.2 Неверный запрос." ||
      props.state.articleCodeMP.response["message"] ===
        "Error #13.5.1 Ошибка подключения, попробуйте снова" ||
      props.state.articleCodeMP.response["message"] === "Не получилось подключится к серверу"
    ) {
      return (
        <div className={s.containerArticle}>
          <img
            className={s.robot}
            src={robort}
          ></img>
          <h1 className={s.errorheader}>Oops, something went wrong, please try again</h1>{" "}
        </div>
      );
    } else if (
      props.state.articleCodeMP.response["message"] ===
        "Error #13.0.0 Недостаточно данных для запроса." ||
      props.state.articleCodeMP.response["message"] ===
        "Error #13.0.1 Недостаточно данных для запроса." ||
      props.state.articleCodeMP.response["message"] === "Error #13.5.2 Данных нет"
    ) {
      return (
        <div className={s.containerArticle}>
          <NotFound />
        </div>
      );
    }
  } else {
    return (
      <div className={s.containerArticle}>
        <NotFound />
      </div>
    );
  }
};
export default ArticleCodeMP;
